module.exports = "/assets/b32460777d24b044e18a9f0945d8efc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MD.png
// module id = 2734
// module chunks = 0